import {Component} from '@angular/core';

@Component({
    selector: 'app-walkthrough-create-invoice',
    templateUrl: './walkthrough-create-invoice.component.html',
    styleUrls: ['../product-walkthrough.component.scss'],
    standalone: false
})
export class WalkthroughCreateInvoiceComponent
{
}
